import { Button, ButtonProps, useNotify, useRecordContext } from "react-admin";
import PublishIcon from "@material-ui/icons/Print";
import { clientNoJson } from "../../dataProvider";
import { url as URL } from "../../constants";
import { getFileNameFromContentDisposition } from "../../shared/utils";
import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";

interface Props extends ButtonProps {
    paymentSchedule?: boolean;
}

export const DownloadInvoicePdfButton = ({
                                             paymentSchedule = false,
                                             ...props
                                         }: Props) => {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: any) => {
        e.stopPropagation();
        setLoading(true);

        let res = null;

        try {
            res = await clientNoJson(
                `${URL}/invoices/${
                    paymentSchedule ? record.invoice.id : record.id
                }/print_invoice_pdf/`,
                {
                    method: "GET",
                    responseType: "arraybuffer",
                }
            );
        } catch (err) {
            notify("ra.notification.http_error", "error");
            setLoading(false);
            return;
        }

        setLoading(false);

        const data = res.data;

        const url = window.URL.createObjectURL(
            new Blob([data], {
                type: res.headers["content-type"],
            })
        );

        const actualFileName = getFileNameFromContentDisposition(
            res.headers["content-disposition"]
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", actualFileName);
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) link.parentNode.removeChild(link);
    };

    return (
        <Button {...props} label="PDF fattura" onClick={handleSubmit}>
            {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
        </Button>
    );
};